(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .directive('appraiserUserRegionForm', ['$q', 'CitySearch', appraiserUserRegionForm]);

    function appraiserUserRegionForm ($q, CitySearch) {
        var directive = {
            restrict: 'E',
            link:  postLink,
            templateUrl: "app/components/form/appraiser-user-region-form/appraiser-user-region-form.template.html",
            scope: {
                appraiserUser: "=appraiserUser"
            }
        };

        return directive;

        function postLink(scope, elm, attrs) {

            scope.cities = {};
            scope.citiesLoading = {};
            scope.expandedRegions = {};
            var pendingLoads = {};

            scope.citiesPerRow = 4;
            scope.cityRows = cityRows;

            scope.citySelected = citySelected;
            scope.toggleCity = toggleCity;
            scope.selectAll = selectAllWithLoad;
            scope.selectNone = selectNoneWithLoad;
            scope.toggleRegionPanel = toggleRegionPanel;
            scope.ensureCitiesLoaded = ensureCitiesLoaded;

            if (scope.appraiserUser && !angular.isArray(scope.appraiserUser.cities)) {
                scope.appraiserUser.cities = [];
            }

            function cityQuery(regionId) {
                return {
                    regionId: regionId,
                    size: 2000,
                    sort: "name,asc"
                };
            }

            function isRegionStillSelected(regionId) {
                if (!scope.appraiserUser || !scope.appraiserUser.regions) {
                    return false;
                }
                var found = false;
                angular.forEach(scope.appraiserUser.regions, function(r) {
                    if (r.id === regionId) {
                        found = true;
                    }
                });
                return found;
            }

            function ensureCitiesLoaded(regionId) {
                if (scope.cities[regionId]) {
                    return $q.when(scope.cities[regionId]);
                }
                if (pendingLoads[regionId]) {
                    return pendingLoads[regionId];
                }
                scope.citiesLoading[regionId] = true;
                pendingLoads[regionId] = CitySearch.query(cityQuery(regionId)).$promise.then(function(cities) {
                    delete pendingLoads[regionId];
                    scope.citiesLoading[regionId] = false;
                    if (isRegionStillSelected(regionId)) {
                        scope.cities[regionId] = cities;
                    }
                    return cities;
                }, function() {
                    delete pendingLoads[regionId];
                    scope.citiesLoading[regionId] = false;
                    return $q.reject();
                });
                return pendingLoads[regionId];
            }

            function loadAllRegionsCities() {
                if (!scope.appraiserUser || !scope.appraiserUser.regions || scope.appraiserUser.regions.length === 0) {
                    return $q.when();
                }
                var promises = [];
                angular.forEach(scope.appraiserUser.regions, function(region) {
                    promises.push(ensureCitiesLoaded(region.id));
                });
                return $q.all(promises);
            }

            function citySelected(city) {
                if (!scope.appraiserUser.cities) {
                    return false;
                }
                var index = scope.appraiserUser.cities.map(function (testCity) {
                    return testCity.id;
                }).indexOf(city.id);
                return index > -1;
            }

            function toggleCity(city) {
                if (!scope.appraiserUser.cities) {
                    scope.appraiserUser.cities = [];
                }
                var index = scope.appraiserUser.cities.map(function (testCity) {
                    return testCity.id;
                }).indexOf(city.id);

                if (index > -1) {
                    scope.appraiserUser.cities.splice(index,1);
                } else {
                    scope.appraiserUser.cities.push(city);
                }
            }

            function toggleRegionPanel(region) {
                var id = region.id;
                if (scope.expandedRegions[id]) {
                    scope.expandedRegions[id] = false;
                    return;
                }
                angular.forEach(scope.appraiserUser.regions, function(r) {
                    scope.expandedRegions[r.id] = (r.id === id);
                });
                ensureCitiesLoaded(id);
            }

            function cityRows(regionId) {
                if (scope.cities[regionId]) {
                    return new Array(Math.ceil(scope.cities[regionId].length / scope.citiesPerRow));
                }
                return [];
            }

            function applySelectAll(regionId) {
                if (!scope.cities[regionId]) {
                    return;
                }
                if (!scope.appraiserUser.cities) {
                    scope.appraiserUser.cities = [];
                }
                angular.forEach(scope.cities[regionId], function(city) {
                    var index = scope.appraiserUser.cities.map(function (testCity) {
                        return testCity.id;
                    }).indexOf(city.id);

                    if (index === -1) {
                        scope.appraiserUser.cities.push(city);
                    }
                });
            }

            function applySelectNone(regionId) {
                if (!scope.cities[regionId]) {
                    return;
                }
                if (!scope.appraiserUser.cities) {
                    return;
                }
                angular.forEach(scope.cities[regionId], function(city) {
                    var index = scope.appraiserUser.cities.map(function (testCity) {
                        return testCity.id;
                    }).indexOf(city.id);

                    if (index > -1) {
                        scope.appraiserUser.cities.splice(index,1);
                    }
                });
            }

            function selectAllWithLoad(regionId) {
                ensureCitiesLoaded(regionId).then(function() {
                    applySelectAll(regionId);
                });
            }

            function selectNoneWithLoad(regionId) {
                ensureCitiesLoaded(regionId).then(function() {
                    applySelectNone(regionId);
                });
            }

            function pruneCitiesCacheForRemovedRegions() {
                if (!scope.appraiserUser || !scope.appraiserUser.regions) {
                    return;
                }
                var keep = {};
                angular.forEach(scope.appraiserUser.regions, function(r) {
                    keep[r.id] = true;
                });
                var toRemove = [];
                angular.forEach(scope.cities, function(_, regionIdKey) {
                    var rid = parseInt(regionIdKey, 10);
                    if (!keep[rid]) {
                        toRemove.push(regionIdKey);
                    }
                });
                angular.forEach(toRemove, function(regionIdKey) {
                    var rid = parseInt(regionIdKey, 10);
                    delete scope.cities[regionIdKey];
                    delete scope.expandedRegions[rid];
                    delete scope.citiesLoading[rid];
                    delete pendingLoads[rid];
                });
            }

            scope.$watch(function() { return scope.appraiserUser ? scope.appraiserUser.regions : null; }, function() {
                pruneCitiesCacheForRemovedRegions();
            }, true);

            scope.$watch(function() { return scope.appraiserUser ? scope.appraiserUser.regionOverride : null; }, function(newVal) {
                if (newVal && scope.appraiserUser && (!scope.appraiserUser.cities || scope.appraiserUser.cities.length === 0) && scope.appraiserUser.regions && scope.appraiserUser.regions.length) {
                    loadAllRegionsCities().then(function() {
                        angular.forEach(scope.appraiserUser.regions, function(region) {
                            applySelectAll(region.id);
                        });
                    });
                }
            });
        }
    }
})();
